/**
 * Shared helpers: copy line item properties from the main cart product to add-ons.
 */
(function (window) {
  'use strict';

  function isAddonCartItem(item) {
    if (item.product_type && item.product_type.indexOf('Add On') !== -1) {
      return true;
    }

    return false;
  }

  function getLinePropertiesFromCart(cart) {
    var properties = {};
    var mainItem = null;
    var items = cart && cart.items ? cart.items : [];

    for (var i = 0; i < items.length; i++) {
      if (!isAddonCartItem(items[i])) {
        mainItem = items[i];
        break;
      }
    }

    if (!mainItem || !mainItem.properties) {
      return properties;
    }

    Object.keys(mainItem.properties).forEach(function (key) {
      if (key === 'Message') {
        return;
      }

      var value = mainItem.properties[key];
      if (value === null || value === undefined || value === '') {
        return;
      }

      properties[key] = value;
    });

    return properties;
  }

  function addAddonToCart(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: parseInt(quantity, 10) || 1,
        properties: properties || {}
      })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw data;
        }
        return data;
      });
    });
  }

  window.AddonCartProps = {
    isAddonCartItem: isAddonCartItem,
    getLinePropertiesFromCart: getLinePropertiesFromCart,
    addAddonToCart: addAddonToCart
  };
})(window);

(function ($) {
  'use strict';

  if (!$) {
    return;
  }

  function initAddonProductPageForm() {
    var $form = $('#AddToCartForm[data-is-addon="true"]');
    if (!$form.length || !window.AddonCartProps) {
      return;
    }

    $form.on('submit.addonPageProps', function (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var $btn = $('#AddToCart');
      var variantId = $form.find('[name="id"]').val();
      var quantity = parseInt($form.find('[name="quantity"]').val(), 10) || 1;

      if (!variantId || $btn.prop('disabled')) {
        return false;
      }

      $btn.prop('disabled', true).addClass('is-adding');
      $('.qty-error').remove();

      fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var properties = window.AddonCartProps.getLinePropertiesFromCart(cart);
          return window.AddonCartProps.addAddonToCart(variantId, quantity, properties);
        })
        .then(function () {
          if (typeof ShopifyAPI !== 'undefined' && ShopifyAPI.getCart) {
            ShopifyAPI.getCart(function (cart) {
              $btn.removeClass('is-adding').addClass('is-added');
              $btn.prop('disabled', false);
              $(document.body).trigger('afterCartLoad.ajaxCart', cart);
            });
            return;
          }

          window.location.href = '/cart';
        })
        .catch(function (error) {
          $btn.removeClass('is-adding is-added').prop('disabled', false);
          var message = (error && (error.description || error.message)) || 'Could not add to cart.';
          $form.after('<div class="errors qty-error">' + message + '</div>');
        });

      return false;
    });
  }

  $(initAddonProductPageForm);
})(window.jQuery);
